import { Component, OnInit } from "@angular/core";
import { ProductQualificationService } from "./shared/product-qualification.service";
import { authenticationService } from "@app/login/auth.service";
import { Permissions } from "@models/permissions.enum";

declare var $: any;

@Component({
  selector: "app-product-qualifications",
  templateUrl: "./product-qualifications.component.html",
  styleUrls: ["./product-qualifications.component.css"],
})
export class ProductQualificationsComponent implements OnInit {
  productQualifications: any[] = [];
  selProductQualification: any = null;
  modalError: string = "";
  is_edit: boolean = false;
  btn: string = "Save";

  colsProductQualification = [
    { field: "name", header: "Name" },
    { field: "avatarFieldName", header: "Avatar Field Name" }
  ];

  constructor(
    private productQualificationService: ProductQualificationService,
    private authService: authenticationService
  ) {}

  ngOnInit() {
    this.loadProductQualifications();
  }

  loadProductQualifications() {
    this.productQualificationService.list().subscribe(
      (data: any) => {
        this.productQualifications = data;
      },
      (error) => {
        console.error("Error loading product qualifications:", error);
      }
    );
  }

  viewDetail(productQualification: any) {
    this.modalError = "";
    if (productQualification) {
      this.selProductQualification = { ...productQualification };
      this.is_edit = true;
      this.btn = "Update";
    } else {
      this.selProductQualification = {
        name: "",
        avatarFieldName: "",
      };
      this.is_edit = false;
      this.btn = "Save";
    }
    $("#addProductQualificationModal").modal("show");
  }

  enableEdit() {
    this.is_edit = false;
  }

  editOn() {
    if (!this.selProductQualification.name || !this.selProductQualification.avatarFieldName) {
      this.modalError = "Name and Avatar Field Name are required";
      return;
    }

    if (this.selProductQualification.id) {
      this.update();
    } else {
      this.create();
    }
  }

  create() {
    this.productQualificationService.create(this.selProductQualification).subscribe(
      (response: any) => {
        this.loadProductQualifications();
        $("#addProductQualificationModal").modal("hide");
      },
      (error) => {
        this.modalError = error.message || "Error creating product qualification";
      }
    );
  }

  update() {
    this.productQualificationService.update(this.selProductQualification).subscribe(
      (response: any) => {
        this.loadProductQualifications();
        $("#addProductQualificationModal").modal("hide");
      },
      (error) => {
        this.modalError = error.message || "Error updating product qualification";
      }
    );
  }

  delete() {
    if (confirm("Are you sure you want to delete this product qualification?")) {
      this.productQualificationService.delete(this.selProductQualification.id).subscribe(
        (response: any) => {
          this.loadProductQualifications();
          $("#addProductQualificationModal").modal("hide");
        },
        (error) => {
          this.modalError = error.message || "Error deleting product qualification";
        }
      );
    }
  }

  hasPermission(permissionName: string): boolean {
    const permission = Permissions[permissionName];
    return this.authService.hasPermission(permission);
  }
}
